import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

// table(components)

// boostraps

import {
  Badge,
  Button,
  Dropdown,
  DropdownMenu,
  Form,
  OverlayTrigger,
  Tabs,
  Tooltip,
} from "react-bootstrap";

// icons

// sub form
import StudyEditor from "./StudyEditor";
// redux
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";
import ScreenCapture from "./ScreenCapture";
import SqlSearchTypeA from "../components/SqlSearchTypeA";
import { BsFilePerson } from "react-icons/bs";

import { EngDateFormatNoSplit } from "../../core/ThaiDate";
import CapturedImageViewer from "./CapturedImageViewer";
import SearchBrchGoodPopup from "./SearchBrchGoodPopup";
import SearchTypeB from "../components/SearchTypeB";
import { FcCancel, FcCheckmark, FcDisclaimer, FcMinus } from "react-icons/fc";
import { ClearOldSession, CreateTooltip } from "../../core/Helper";
import StudyShowResult from "./StudyShowResult";
import { useContext } from "react";
import { WsCmmdContext } from "../../App";
import Loading from "../../components/Loading";
import { BiRefresh, BiSearch } from "react-icons/bi";
import { encode } from "js-base64";
import ConfirmDialogB from "../components/ConfirmDialogB";
import { useNavigate } from "react-router-dom";
import StudyHistoryTracking from "../admin/report-study-history";
import ExternalResulting from "./ExternalResulting";
import { StudyService } from "../../model/study";
import InvoiceSelector from "../../invoices/invoice_selector";
import { GetCreateTable } from "../../core/Helper2";
import { GetWorkListColumns } from "./TechWorrklist_Columns";
import { BuildContextItem, IconName } from "./TechWorklist_MenuPopup";
import DateRangeFilterBar from "../../components/DateRangeFilterBar";

export default function TechWorklist() {
  const userDetail = useSelector((state) => state.user.detail);
  const scrollTop = useSelector((state) => state.scrollTrack.value.scTop);
  const scrollLeft = useSelector((state) => state.scrollTrack.value.scLeft);
  const theme = useSelector((s) => s.theme.theme);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [table1, setTable1] = useState();
  const [table2, setTable2] = useState();
  const [showCtx, setShowCtx] = useState(false);
  const [showEditor, setShowEditor] = useState({ show: false });
  const [showScreenCapture, setShowScreenCapture] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [refData, setRefData] = useState(null);
  const [captureResult, setCaptureResult] = useState(false);
  const [searchA, setSearchA] = useState({ show: false, action: () => {} });
  const [searchB, setSearchB] = useState({ show: false, action: () => {} });
  const [showImageView, setShowImageView] = useState(false);
  const [studyTrack, setStudyTrack] = useState({ show: false });
  const [searchGood, setSearchGood] = useState({
    show: false,
    aciton: () => {},
  });
  const [updateFlag, setUpdateFlag] = useState(true);
  const [params, setParams] = useState({
    goodcateid: -1,
    gdmodid: -1,
    gdspecialtyid: -1,
    gdspcsubid: -1,
    custid: -1,
    custid_sender: -1,
    brchpatrightid: -1,
    price_list_id: -1,
  }); //* parameters สำหรับค้นหาสินค้าด้วย รหัสสินค้ากับรหัสสิทธิรักษา  **/
  const [searchParams, setSearchParams] = useState(null);
  const [dateRangeValues, changeDateRange] = useState([new Date(), new Date()]);

  const [showStudyResult, setShowStudyResult] = useState({ show: false });

  const [winPdfState, setWinPdfState] = useState({ show: false });

  const [loading, setLoading] = useState(false);
  const [dateSelected, setDateSelected] = useState(1);
  const [confirm, setConfirm] = useState({ show: false, action: () => {} });
  const defaultStatusParams = {
    DELAY: true,
    FINALIZED: false,
    RAD_ACCEPTED: false,
    RAD_REJECTED: false,
    OLD_STUDY: false,
    SCAN_COMPLETE: false,
  };
  const defaultSearchCondition = {
    PatientName: false,
    HN: false,
    Modality: false,
    Radiologist: false,
  };
  const [statusParam, setStatusParam] = useState(defaultStatusParams);
  const [searchCondition, setSearchCondition] = useState([]);

  const defaultExternalResulting = { show: false, row: null, action: () => {} };
  const [externalResuting, setExternalResulting] = useState(
    defaultExternalResulting,
  );
  const [mouseXY, setMouseXY] = useState([0, 0]);

  const refMouse = useRef();
  const refTable = useRef();

  const handleContextMenu = (e) => {
    if (selectedRow !== null) {
      setShowCtx(true);
    }
    e.preventDefault();
  };

  const [cmmd, setCmmd] = useContext(WsCmmdContext);
  const [ctxMode, setCtxMode] = useState("normal");
  const [searchTxt, setSearchTxt] = useState("");

  const [contextMenuList, setContextMenuList] = useState();

  const timeLineCheck = (e) => {
    setStudyTrack({
      show: true,
      data: {
        PacsStudyId: selectedRow?.pacs_study_id ?? 0,
      },
    });
    setShowCtx(false);
  };

  /**
   * คลิกเมนูส่งผลจากภายนอก
   * @param {*} e
   */
  const setExternalReport = (e) => {
    setExternalResulting({
      show: true,
      data: selectedRow,
      action: (e) => {
        getData(false);
      },
    });
    setShowCtx(false);
  };

  /// context menu list
  const ctxMenuItem = [
    {
      icon: IconName.PATIENT_EDITOR,
      onClick: () => showEditorAction(false),
      disabled: selectedRow?.is_study_old === "y" ? true : false,
    },
    {
      icon: IconName.PRINT_REPORT,
      onClick: () => showResultAction(),
      hidden: selectedRow?.rad_resulted !== "y",
    },
    {
      icon: IconName.MARK_AS_VERIFY,
      onClick: () => ConfirmsVerifiedCase(),
      hidden: selectedRow?.diag_finish !== "y",
    },
    {
      icon: IconName.CHECK_STUDY_PROGRESS,
      onClick: () => timeLineCheck(),
    },
    {
      icon: IconName.PAST_EXTERNAL_REPORT,
      onClick: () => setExternalReport,
      hidden:
        selectedRow?.diag_finish == "y" ||
        selectedRow?.is_study_old == "y" ||
        selectedRow?.rad_accepted == "y",
    },
    {
      icon: IconName.STUDY_REVIEWS,
      onClick: () => ConfirmsReviewCase(false),
      hidden:
        selectedRow?.diag_finish == "n" || selectedRow?.is_study_old == "y",
    },
    {
      icon: IconName.BILLING_ISSUED,
      onClick: () => InvoiceHandler(),
      hidden: selectedRow?.is_study_old == "y",
    },
    {
      icon: IconName.SET_OLD_STUDY,
      hidden:
        selectedRow?.diag_finish == "y" || selectedRow?.rad_accepted == "y",
      onClick: () => showEditorAction(true),
    },
    {
      icon: IconName.CANCEL_STUDY,
      hidden: selectedRow?.diag_finish == "y",
      onClick: () => ConfirmsRemoveCase(),
    },
  ];

  useEffect(() => {
    const getMenu = async () => {
      let bb = await BuildContextItem(ctxMenuItem);
      setContextMenuList(bb);
    };
    getMenu();
    // return () => {
    //   setContextMenuList(null);
    // };
  }, [selectedRow]);

  useEffect(() => {
    if (showEditor.show === false) {
      getData(true);
    }
  }, [dateRangeValues]);

  useEffect(() => {
    refMouse.current.style.left = `${scrollLeft + mouseXY[0] - 7}px`;
    refMouse.current.style.top = `${scrollTop + mouseXY[1] - 7}px`;
  }, [mouseXY]);

  const buildTable = (state, data, isNormal) => {
    const [tb, setTb] = state;
    setTb(
      GetCreateTable({
        ...{
          idFieldName: "pacs_study_id",
          columns: GetWorkListColumns(isNormal),
          data: data,
        },
        ...{ selectRow, defaultSorted, rowEvents, defaultSorted },
      }),
    );
  };

  useEffect(() => {
    buildTable([table1, setTable1], data, true);
  }, [data]);

  useEffect(() => {
    buildTable([table2, setTable2], data2);
  }, [data2]);

  // ---------------------------------------------------------------------
  useEffect(() => {
    if (
      !(
        showEditor.show ||
        showStudyResult.show ||
        externalResuting.show ||
        studyTrack.show
      )
    ) {
      document.addEventListener("contextmenu", handleContextMenu);
    } else {
      document.removeEventListener("contextmenu", handleContextMenu);
    }

    /**เช็คการเปิดผลผ่าน Line */
    checkOpenStudyFromSession();

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [
    showEditor?.show,
    selectedRow,
    showStudyResult,
    externalResuting,
    studyTrack,
  ]);

  // ----------------
  useEffect(() => {
    if (updateFlag) {
      getData(true);
      setUpdateFlag(false);
    }
  }, [updateFlag]);

  //** Timer refreshdata */
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (showEditor.show === false) {
        getData(false);
      }
    }, 25000);

    return () => {
      clearInterval(intervalId);
    };
  }, [showEditor, dateRangeValues, statusParam, searchCondition, searchTxt]);

  // ต้งค่าตัวเลือกสิทธิรักษาอันแรก
  useEffect(() => {
    if (refData) {
      setParams((pv) => ({
        ...pv,
        brchpatrightid: refData?.PatientRight?.[0]?.brchpatrightid,
        price_list_id: refData?.FirstPriceList?.[0]?.price_list_id,
      }));
    }
  }, [refData]);

  // ---------------------------------------------------------------------
  // ** receive study components data {patient-right, }..
  useEffect(() => {
    getComponents();
    return () => {
      setRefData([]);
    };
  }, []);
  // ---------------------------------------------------------------------

  const getComponents = async () => {
    setLoading(true);
    let res = await StudyService.GetStudyComponents({
      BrchId: userDetail.brchid,
    });
    if (res) {
      setRefData(res);
    } else {
      setRefData([]);
    }
    setLoading(false);
  };

  const openResultFromNotifier = (e) => {
    getSingleStudy(e.detail.studyId, e.detail.messageId, (data) => {
      setSelectedRow(data.rows[0]);
      showResultAction();
    });
  };

  useEffect(() => {
    document.addEventListener(
      "openResultFromNotifyBox",
      openResultFromNotifier,
    );
    checkOpenStudyFromSession();
    return () => {
      document.removeEventListener(
        "openStudyFromNotifyBox",
        openResultFromNotifier,
      );
    };
  }, []);

  const getSingleStudy = async (pacsStudyId, messageId, callback) => {
    let res = await StudyService.GetSingleStudyRadi({
      UserInfo: userDetail,
      StudyInfo: pacsStudyId,
    });
    if (res) {
      callback(res);
    } else {
      callback(null);
    }
  };

  // ลบเคส
  const ConfirmsRemoveCase = () => {
    setShowCtx(false);

    if (selectedRow?.diag_finish === "y") {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถยกเลิกเคสได้เนื่องจากมีการอ่านผลแล้ว",
          type: "error",
        }),
      );
      return;
    }
    if (selectedRow?.rad_accepted === "y") {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถยกเลิกเคสได้เนื่องแพทย์รับเคสแล้ว",
          type: "error",
        }),
      );
      return;
    }
    if (selectedRow?.inform_rad === "y") {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถยกเลิกเคสได้เนื่องจากแจ้งรังสีแพทย์แล้ว",
          type: "error",
        }),
      );
      return;
    }

    setConfirm({
      show: true,
      title: "กรุณายืนยันการยกเลิกเคสอีกครั้ง",
      action: (comeback) => {
        if (comeback === true) {
          RemovesStudy();
        }
      },
    });
  };

  const RemovesStudy = async () => {
    let res = await StudyService.DeleteUnWantedStudy({
      data: encode(
        JSON.stringify({
          userid: userDetail?.userid,
          studyUid: selectedRow?.study_instance_uid,
        }),
      ),
    });

    if (res) {
      getData(false);
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "พบปัญหาการยกเลิก",
          type: "error",
        }),
      );
    }
  };

  const ConfirmsVerifiedCase = () => {
    setShowCtx(false);

    if (selectedRow?.is_study_old === "y") {
      dispatch(
        setReminder({
          show: true,
          message: "ส่งภาพเก่า ไม่สามารถเปลี่ยนสถานะเป็น Verify ได้",
          type: "error",
        }),
      );
      return;
    }

    if (selectedRow?.diag_finish === "n") {
      dispatch(
        setReminder({
          show: true,
          message: "สถานะเคสยังไม่ได้รับผลสิ้นสุด ไม่สามารถเปลี่ยนสถานะได้",
          type: "error",
        }),
      );
      return;
    }

    setConfirm({
      show: true,
      title: "ยืนยันการ Verify",
      action: (comeback) => {
        if (comeback === true) {
          SetVerifiedStudy();
        }
      },
    });
  };

  const ConfirmsReviewCase = () => {
    setShowCtx(false);

    setConfirm({
      show: true,
      title: "ยืนยันการที่จะส่ง Review",
      action: (comeback) => {
        if (comeback === true) {
          SetReviewedStudy();
        }
      },
    });
  };

  const SetVerifiedStudy = async () => {
    let res = await StudyService.SetVerifiedStudy({
      data: encode(
        JSON.stringify({
          userid: userDetail?.userid,
          studyUid: selectedRow?.study_instance_uid,
        }),
      ),
    });
    if (res) {
      getData(false);
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถตั้ง Verify ได้",
          type: "error",
        }),
      );
    }
  };

  const SetReviewedStudy = async () => {
    let res = await StudyService.SetReviewedStudy({
      data: encode(
        JSON.stringify({
          userid: userDetail?.userid,
          studyUid: selectedRow?.study_instance_uid,
        }),
      ),
    });
    if (res) {
      getData(false);
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "พบปัญหา ไม่สามารถ Reviewe ได้",
          type: "error",
        }),
      );
    }
  };

  const navigate = useNavigate();

  /** เปิดผลอ่านผ่าน web */
  //** เช็คการเปิดจาก app อื่น เช่น link ผ่านไลน์ */
  const checkOpenStudyFromSession = () => {
    let pacsStudyId = sessionStorage.getItem("radconn_pacs_study_id");
    let radStaffId = sessionStorage.getItem("radconn_staff_id");
    let type = sessionStorage.getItem("radconn_param_type");
    let messageId = sessionStorage.getItem("message_id");

    if (type === "admin_result") {
      if (pacsStudyId && radStaffId) {
        getSingleStudy(pacsStudyId, 0, (data) => {
          setSelectedRow(data.rows[0]);
          showResultAction();
        });
      }
      ClearOldSession();
    } else if (type === "admin_verify_case") {
      navigate("/home");
    } else if (type === "admin_inform") {
      getSingleStudy(pacsStudyId, 0, (data) => {
        setSelectedRow(data.rows[0]);
        showEditorAction(false);
        ClearOldSession();
      });
    }
  };

  /** เปิดผล pdf  */
  const showResultAction = () => {
    setShowStudyResult({
      show: true,
      action: () => {
        setShowStudyResult({ show: true });
      },
    });

    setShowCtx(false); // close popup menu
  };

  // ---------------------------------------------------------------------
  // ค้นหาข้อมูล

  const getData = async (showLoader) => {
    setLoading(showLoader);
    let paramsX = { patients_name: searchTxt };
    let res = await StudyService.ListStudies({
      BrchId: userDetail.brchid,
      DateRange: [
        EngDateFormatNoSplit(dateRangeValues[0]),
        EngDateFormatNoSplit(dateRangeValues[1]),
      ],
      SearchInfo: paramsX,
      SearchCondition: searchCondition,
      StatusParams: statusParam,
      SearchText: searchTxt,
    });

    if (res) {
      setData(res.rows);
      setData2(res.rows2);
    } else {
      setData([]);
      setData2([]);
    }
    setLoading(false);
  };
  // ---------------------------------------------------------------------

  const [invoiceState, setInvoiceState] = useState({
    show: false,
    action: () => {},
    data: null,
  });
  const InvoiceHandler = () => {
    setInvoiceState({ show: true, action: (ret) => {}, data: selectedRow });
    setShowCtx(false);
  };

  const changedStatusCheck = (e) => {
    setStatusParam((p) => {
      p["DELAY"] = false;
      p[e.target.name] = e.target.checked;
      return { ...p };
    });
  };

  const changedConditionCheck = (e) => {
    if (e.target.checked) setSearchCondition((p) => [...p, e.target.value]);
    else setSearchCondition((p) => p.filter((item) => item != e.target.value));
  };

  useEffect(() => {
    if (statusParam.DELAY === false) {
      getData();
    }
  }, [statusParam]);

  const defaultSorted = [
    {
      dataField: "upload_date",
      order: "desc",
    },
    {
      dataField: "study_time",
      order: "desc",
    },
  ];
  // --------------------------------------
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      UpdateMouseCursor(e);
    },
    onDoubleClick: (e, row, rowIndex) => {
      /**ุถ้าเป็นเคสใหม่=>รับเคส=>บันทึกผล */
      let isOld = row?.is_study_old === "y" ? true : false;
      showEditorAction(isOld);
    },
    onMouseEnter: (e, row, rowIndex) => {
      setShowCtx(false);
      UpdateSelectedRow(row);
      UpdateMouseCursor(e);
    },
    onMouseMove: (e, row, rowIndex) => {
      refMouse.current.style.left = `${e.clientX - 7}px`;
    },
    onMouseDown: (e, row, rowIndex) => {
      UpdateMouseCursor(e);
    },
  };

  const UpdateMouseCursor = (e) => {
    setMouseXY([e.clientX, e.clientY]);
  };
  const UpdateSelectedRow = (row) => {
    setSelectedRow(row);
  };

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    classes: "row-h-over-selected",
    hideSelectColumn: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      UpdateMouseCursor(e);
      UpdateSelectedRow(row);
    },
  };

  //--------------------------------------
  const showEditorAction = (oldstudy) => {
    setShowEditor({
      show: true,
      isOldStudy: oldstudy,
    });
    setShowCtx(false);
  };

  /** ตัวเลือกการค้นหา */
  let formCheckItems = [
    { label: "ชื่อคนไข้", name: "PatientName", fieldName: "a.patients_name" },
    { label: "HN", name: "HN", fieldName: "a.patientid" },
    { label: "Modality", name: "Modality", fieldName: "a.modality" },
    {
      label: "Description",
      name: "Description",
      fieldName: "a.study_description",
    },
  ];

  return (
    <MainBox>
      {loading ? <Loading /> : <></>}
      <div className="page-title-header">
        <BsFilePerson style={{ color: "#12ddf4", marginRight: "5px" }} />
        {"รายชื่อคนไข้ตรวจ"}
      </div>

      <div className="top-long-bar">
        <HBox>
          <DateRangeFilterBar
            {...{ dateRange: [dateRangeValues, changeDateRange] }}
          />
        </HBox>

        <HBox>
          <div
            style={{
              color: "white",
              flex: "2",
              padding: "3px",
            }}
          >
            <div
              style={{
                flex: "1",
                paddingTop: "5px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {}
              {/*  */}
              <div style={{ flex: "1", display: "flex", flexDirection: "row" }}>
                <Dropdown1 variant="secondary">
                  <Dropdown.Toggle id="dropdown-basic">ค้นหา</Dropdown.Toggle>
                  <DropdownMenu1>
                    {formCheckItems.map((item, i) => {
                      return (
                        <Form.Check
                          label={item.label}
                          name={item.name}
                          value={item.fieldName}
                          onChange={changedConditionCheck}
                        />
                      );
                    })}
                  </DropdownMenu1>
                </Dropdown1>

                <SearchInput
                  type="text"
                  value={searchTxt}
                  onChange={(e) => {
                    setSearchTxt(e.target.value);
                  }}
                  placeholder="ข้อความค้นหา.."
                />
                {searchTxt !== "" ? (
                  CreateTooltip(
                    "Clear",
                    <ButtonClearSearch
                      variant="danger"
                      onClick={() => {
                        setSearchTxt("");
                      }}
                    >
                      x
                    </ButtonClearSearch>,
                  )
                ) : (
                  <></>
                )}

                <Dropdown1 variant="secondary">
                  <Dropdown.Toggle id="dropdown-basic">
                    เฉพาะสถานะ
                  </Dropdown.Toggle>
                  <DropdownMenu1>
                    <Form.Check
                      label="Finalize"
                      name="FINALIZED"
                      onChange={changedStatusCheck}
                    />
                    <Form.Check
                      label="พ.รับเคส"
                      name="RAD_ACCEPTED"
                      onChange={changedStatusCheck}
                    />
                    <Form.Check
                      label="แพทย์ปฏิเสธเคส"
                      name="RAD_REJECTED"
                      checked={statusParam.RAD_REJECTED}
                      onChange={changedStatusCheck}
                    />
                    <Form.Check
                      label="ส่งเคสเก่า"
                      name="OLD_STUDY"
                      onChange={changedStatusCheck}
                    />
                    <Form.Check
                      label="รอส่งอ่าน"
                      name="SCAN_COMPLETE"
                      onChange={changedStatusCheck}
                    />
                  </DropdownMenu1>
                </Dropdown1>
              </div>
              <OverlayTrigger
                placement="top"
                overlay={(props) => (
                  <Tooltip {...props}>
                    {searchTxt === "" ? "Refresh" : "ค้นหา"}
                  </Tooltip>
                )}
              >
                <Button
                  // variant={theme.themeName}
                  style={{
                    borderRadius: "60px",
                    maxHeight: "80px",
                  }}
                  onClick={() => {
                    getData(true);
                  }}
                >
                  {searchTxt != "" ? (
                    <BiSearch color="#09f829" size={30} />
                  ) : (
                    <BiRefresh color="#09f829" size={30} />
                  )}
                </Button>
              </OverlayTrigger>
            </div>
          </div>
        </HBox>
      </div>
      <Tabs
        style={{
          background: "var(--bg-primary)",
          marginTop: "3px",
          paddingTop: "10px",
        }}
        id="controlled-tab-example"
        activeKey={ctxMode}
        className="mb-2"
        variant="tabs"
        onSelect={(e) => {
          /**set 'wait' or 'diag' */
          setSelectedRow(null);
          setCtxMode(e);
        }}
        justify
      >
        <TabDiv
          eventKey="normal"
          title={
            <span>
              {/* <AiTwotoneCalendar color="#13eb42" size={18} /> */}
              Case ปรกติ {""}
              <Badge bg="success" style={styles.badgeInner}>
                {data?.length ?? 0}
              </Badge>
              {""}
            </span>
          }
        >
          {table1}
        </TabDiv>

        {/* Tab B */}

        <TabDiv
          eventKey="critical"
          title={
            <span>
              <FcDisclaimer color="#ffff00" size={20} /> Case มีปัญหารอจัดการ{" "}
              <Badge bg="danger" style={styles.badgeInner}>
                {data2?.length ?? 0}
              </Badge>
            </span>
          }
        >
          {table2}
        </TabDiv>
      </Tabs>

      {/** Float point to show menu context when have right-click mouse button */}
      <OverlayTrigger
        show={showCtx}
        placement="right"
        overlay={contextMenuList}
      >
        <MotionBox ref={refMouse} />
      </OverlayTrigger>

      <StudyEditor
        {...{
          ...{ showEditor: [showEditor, setShowEditor] },
          userDetail,
          //setShowEditor,
          selectedRow,
          setShowCtx,
          refData,
          showScreenCapture,
          setShowScreenCapture,
          searchState: [searchA, setSearchA],
          showImage: [showImageView, setShowImageView],
          searchGood: [searchGood, setSearchGood],
          searchB: [searchB, setSearchB],
          params: [params, setParams],
          updateFlag: [updateFlag, setUpdateFlag],
          loading,
          setLoading,
        }}
      />
      <ScreenCapture
        {...{
          showScreenCapture,
          setShowScreenCapture,
          userDetail,
          selectedRow,
          setCaptureResult,
        }}
      ></ScreenCapture>
      <SqlSearchTypeA {...{ winState: [searchA, setSearchA] }} />
      <SearchTypeB {...{ winState: [searchB, setSearchB] }} />
      <CapturedImageViewer
        {...{ showImage: [showImageView, setShowImageView] }}
      />
      <SearchBrchGoodPopup
        {...{
          winState: [searchGood, setSearchGood],
          params: [params, setParams],
        }}
      />

      <StudyShowResult
        {...{
          userDetail,
          showStudyResult,
          setShowStudyResult,
          setShowCtx,
          selectedRow,
          refData,
          showScreenCapture,
          setShowScreenCapture,
          searchState: [searchA, setSearchA],
          showImage: [showImageView, setShowImageView],
          searchGood: [searchGood, setSearchGood],
          searchB: [searchB, setSearchB],
          params: [params, setParams],
          updateFlag: [updateFlag, setUpdateFlag],
          enableSave: true,
          loading: [loading, setLoading],
          // template:[templateEditor, setTemplateEditor]
        }}
      />
      <StudyHistoryTracking {...{ winState: [studyTrack, setStudyTrack] }} />
      <ExternalResulting
        {...{ winState: [externalResuting, setExternalResulting] }}
      />
      <InvoiceSelector {...{ winState: [invoiceState, setInvoiceState] }} />
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
    </MainBox>
  );
}

const MainBox = styled.div`
  min-width: ${(props) => props.win_width}px;
  //min-height: 90vh;
  //overflow-x: scroll;
  //overflow-y: "none";
`;

const MotionBox = styled.div`
  position: absolute;
  top: 100px;
  left: 100px;
  height: 15px;
  width: 15px;
  background-color: #4df809;
  opacity: 1;
  z-index: -2; //-2
`;

const HBox = styled.div`
  display: flex;
`;

const VBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const SBox = styled.div`
  color: white;
  margin: 5px;
  flex: 1;
`;

const styles = {
  icon: { color: "#2731ff", marginRight: "5px" },
  listItem: { color: "#242323" },
  buttonFilter: { marginRight: "2px" },
};

const SearchInput = styled.input`
  display: flex;
  background-color: #121212;
  border: 1px solid #2c2b2b;
  border-radius: 5px;
  margin-left: 3px;
  padding-top: 6px;
  padding-left: 5px;
  padding-bottom: 6px;
  max-width: 150px;
  text-align: center;
  color: #3421df;
  ::placeholder {
    color: #68696d;
  }
`;

const ButtonClearSearch = styled(Button)`
  margin: 2px;
`;

const Dropdown1 = styled(Dropdown)`
  margin-left: 10px;
  margin-top: 3px;
`;

const DropdownMenu1 = styled(DropdownMenu)`
  background-color: #0a58ca; // #1b1c2b;
  padding-left: 15px;
  color: #ffff08;
`;

const TabDiv = styled("Tabs")`
  color: "white";
`;
